import { createRouter, createWebHashHistory } from "vue-router";

import HomeOnePage from "@/components/Pages/HomeOnePage.vue";
import HomeTwoPage from "@/components/Pages/HomeTwoPage.vue";
import HomeThreePage from "@/components/Pages/HomeThreePage.vue";
import AboutPage from "@/components/Pages/AboutPage.vue";
import ServicesPage from "@/components/Pages/ServicesPage.vue";
import ServicesTwoPage from "@/components/Pages/ServicesTwoPage.vue";
import ServicesDetailsPage from "@/components/Pages/ServicesDetailsPage.vue";
import ProjectPage from "@/components/Pages/ProjectPage.vue";
import ProjectDetailsPage from "@/components/Pages/ProjectDetailsPage.vue";
import TeamPage from "@/components/Pages/TeamPage.vue";
import AccountPage from "@/components/Pages/AccountPage.vue";
import ApplyPage from "@/components/Pages/ApplyPage.vue";
import PricingPage from "@/components/Pages/PricingPage.vue";
import FaqPage from "@/components/Pages/FaqPage.vue";
import FaqEservicePage from "@/components/Pages/FaqEservicePage.vue";
import TestimonialsPage from "@/components/Pages/TestimonialsPage.vue";
import MyAccountPage from "@/components/Pages/MyAccountPage.vue";
import LoginPage from "@/components/Pages/LoginPage.vue";
import RegisterPage from "@/components/Pages/RegisterPage.vue";
import RecoverPasswordPage from "@/components/Pages/RecoverPasswordPage.vue";
import TermsOfServicePage from "@/components/Pages/TermsOfServicePage.vue";
import PrivacyPolicyPage from "@/components/Pages/PrivacyPolicyPage.vue";
import ErrorPage from "@/components/Pages/ErrorPage.vue";
import BlogPage from "@/components/Pages/BlogPage.vue";
import BlogLeftSidebarPage from "@/components/Pages/BlogLeftSidebarPage.vue";
import BlogRightSidebarPage from "@/components/Pages/BlogRightSidebarPage.vue";
import BlogDetailsPage from "@/components/Pages/BlogDetailsPage.vue";
import BlogDetailsLeftSidebarPage from "@/components/Pages/BlogDetailsLeftSidebarPage.vue";
import BlogDetailsRightSidebarPage from "@/components/Pages/BlogDetailsRightSidebarPage.vue";
import ContactUsPage from "@/components/Pages/ContactUsPage.vue";

import ColisPostauxPage from "@/components/Pages/ColisPostauxPage.vue";
import EnvoiExpressPage from "@/components/Pages/EnvoiExpressPage.vue";
import PhiLateliePage from "@/components/Pages/PhilateliePage.vue";
import PosteLettrePage from "@/components/Pages/PosteLettrePage.vue";
import ServiceDistributionPage from "@/components/Pages/ServiceDistributionPage.vue";
import AssurancePage from "@/components/Pages/AssurancePage.vue";
import CentreChequePage from "@/components/Pages/CentreChequePage.vue";
import CaisseNationalPage from "@/components/Pages/CaisseNationalPage.vue";
import TransfertArgentPage from "@/components/Pages/TransfertArgentPage.vue";
import ServicePublicPage from "@/components/Pages/ServicePublicPage.vue";
import ServicePostePage from "@/components/Pages/ServicePostePage.vue";
import AutreServicePage from "@/components/Pages/AutreServicePage.vue";
import PosteVertePage from "@/components/Pages/PosteVertePage.vue";
import PosteVoyagePage from "@/components/Pages/PosteVoyagePage.vue";
import ProduitPartenariatPage from "@/components/Pages/ProduitPartenariatPage.vue";

import ActualitePostePage from "@/components/Pages/ActualitePostePage.vue";
import MediathequePostePage from "@/components/Pages/MediathequePostePage.vue";
import MediathequePosteVideoPage from "@/components/Pages/MediathequePosteVideoPage.vue";
import DocumentPostePage from "@/components/Pages/DocumentPostePage.vue";
import ViewMediathequePage from "@/components/Pages/ViewMediathequePage.vue";
import ViewArticlePage from "@/components/Pages/ViewArticlePage.vue";
import PreviewArticlePage from "@/components/Pages/PreviewArticlePage.vue";
import SimulationPage from "@/components/Pages/SimulationPage.vue";

import MentionLegalPage from "@/components/Pages/MentionLegalePage.vue";
import DonnePersonnellePage from "@/components/Pages/DonnePersonnellePage.vue";
import CooKiePage from "@/components/Pages/CooKiePage.vue";

import ProduitTransfertPage from "@/components/Pages/ProduitTransfertPage.vue";
import ProduitColisPostauxPage from "@/components/Pages/ProduitColisPostauxPage.vue";
import ProduitPosteLettrePage from "@/components/Pages/ProduitPosteLettrePage.vue";
import ProduitEnvoisExpressPage from "@/components/Pages/ProduitEnvoisExpressPage.vue";
import ProduitTransportLocationPage from "@/components/Pages/ProduitTransportLocationPage.vue";
import OrganisationPage from "@/components/Pages/OrganisationPage.vue";
import StatutPage from "@/components/Pages/StatutPage.vue";
import ColloquePage from "@/components/Pages/ColloquePage.vue";
import ConferencePage from "@/components/Pages/ConferencePage.vue";
import BibliothequePage from "@/components/Pages/BibliothequePage.vue";
import RevuPage from "@/components/Pages/RevuPage.vue";
import Disciplepage from "@/components/Pages/DisciplePage.vue";
import Activitepage from "@/components/Pages/ActivitePage.vue";
import LibrairiePage from "@/components/Pages/LibrairiePage.vue";
import CoursPage from "@/components/Pages/CoursPage.vue";
import Seminaire from "@/components/Seminaire/Seminaire.vue";
import LaboratoirePage from "@/components/Pages/LaboratoirePage.vue";
import SeminairePage from "@/components/Pages/SeminairePage.vue";
import PublicationPage from "@/components/Pages/PublicationPage.vue";
import CodeEngagementPage from "@/components/Pages/CodeEngagementPage.vue";
import BenevolePage from "@/components/Pages/BenevolePage.vue";
import SoutienPage from "@/components/Pages/SoutienPage.vue";
import AnimateurPage from "@/components/Pages/AnimateurPage.vue";
import NiveauPersonnelPage from "@/components/Pages/NiveauPersonnelPage.vue";
import AxeAnimationPage from "@/components/Pages/AxeAnimationPage.vue";
import ParutionPage from "@/components/Pages/ParutionPage.vue";
import MatineesPage from "@/components/Pages/MatineesPage.vue";
import MissionPage from "@/components/Pages/MissionPage.vue";
// import QuiSommesNousPage from "@/components/Pages/QuiSommesNousPage.vue";
import EitpMissionPage from "@/components/Pages/EitpMissionPage.vue";
import ChronosKairosPage from "@/components/Pages/ChronosKairosPage.vue";
import RevuePage from "@/components/Pages/RevuePage.vue";
import RecherchePage from "@/components/Pages/RecherchePage.vue";
import FormateurPage from "@/components/Pages/FormateurPage.vue";
import ArticlePage from "@/components/Pages/ArticlePage.vue";
import ActivitePage from "@/components/Pages/ActivitePage.vue";
import DisciplePage from "@/components/Pages/DisciplePage.vue";
import DemandeInscriptionPage from "@/components/Pages/DemandeInscriptionPage.vue";
import FormationPage from "@/components/Pages/FormationPage.vue";
import VideoPage from "@/components/Pages/VideoPage.vue";
import Disciples2Page from "@/components/Pages/Disciples2Page.vue";
import DiscipleEmmaius from "@/components/Les discipleEmmaius/DisciplesEmmaiusPage.vue";
import Equipes from "@/components/LesEquipes/EquipesPage.vue";
import LesMouvements from "@/components/LesMouvements/MouvementPages.vue";
import LesResponsables from "@/components/LesResponsables/LesResponsablesPage.vue";
import LesTuteurs from "@/components/LesTuteurs/LesTuteursPage.vue";
import LesAnimateurs from "@/components/LesAnimateurs/LesAnimateursPage.vue";
import LesProfesseursPage from "@/components/LesProfesseurs/LesProfesseursPage.vue";
import LesSecretariat from "@/components/Sécrétariat/SecretariatPage.vue";
import QuiSommesNousPagess from "@/components/QuiSommesNouss/QuiSommesNousPages.vue";
import ParcoursDisciplesPage from "@/components/ParcoursDisicples/ParcoursDisciplesPage.vue";
import NormeAdministrativePage from "@/components/NormesAdministratives/NormeAdministrativePage.vue";
import ParcourSupPage from "@/components/ParcourSup/ParcourSupPage.vue";
import CafePage from "@/components/CafeTheologique/CafePage.vue";
import MissionEitpPage from "@/components/MissionEITP/MissionEitpPage.vue";
import LaRevuePage from "@/components/RevueEcole/LaRevuePage.vue";

import ParcoursOMEGAPage from "@/components/ParcoursOMEGA/ParcoursOMEGAPage.vue";
import ParcoursUnitePage from "@/components/ParcoursUnite/ParcoursUnitePage.vue";
import DecretPage from "@/components/Decret/DecretPage.vue";
import LesHabituesPage from "@/components/Habitues/LesHabituesPage.vue";
import LesAuditeursPage from "@/components/Auditeurs/LesAuditeursPage.vue";
import LaLiturgiePage from "@/components/Liturgie/LaLiturgiePage.vue";
import LaChorale from "@/components/Chorale/LaChorale.vue";
import LaChoralePage from "@/components/Chorale/LaChoralePage.vue";
import LesOrganisationsPage from "@/components/Organisations/LesOrganisationsPage.vue";
import LesAmisPage from "@/components/Amis/LesAmisPage.vue";
import AmiSéminairePage from "@/components/AmiSéminaire/AmiSéminairePage.vue";
import PetiteVoiePage from "@/components/PetiteVoie/PetiteVoiePage.vue";
import ProfesseursDetailsPage from "@/components/LesProfesseurs/ProfesseursDetailsPage.vue";
import DisciplesEmmaiusDetailsPage from "@/components/Les discipleEmmaius/DisciplesEmmaiusDetailsPage.vue";
import DiesAcademicusPage from "@/components/DiesAcademicus/DiesAcademicusPage.vue";
import LesSoireestheologiquesPage from "@/components/LesSoireestheologiques/LesSoireestheologiquesPage.vue";
import CeremonieAcademiquePage from "@/components/CeremonieAcadémique/CeremonieAcademiquePage.vue";
import LesColloquesPage from "@/components/LesColloques/LesColloquesPage.vue";
import ParcoursSpirituels from "@/components/LesParcoursSpirituels/ParcoursSpirituels.vue";
import ParcoursSpirituelsPage from "@/components/LesParcoursSpirituels/ParcoursSpirituelsPage.vue";

import LesRetraitePage from "@/components/LesRetraite/LesRetraitePage.vue";
import ConferenceAvantPage from "@/components/ConferenceAvant/ConferenceAvantPage.vue";
import LesRecollectionsPage from "@/components/LesRecollections/LesRecollectionsPage.vue";
import LesPelerinagePage from "@/components/LesPelerinages/LesPelerinagePage.vue";
import RevueCulturePage from "@/components/RevueCulture/RevueCulturePage.vue";
import LeslaboratoiresPage from "@/components/Leslaboratoires/LeslaboratoiresPage.vue";
import LesBibliothequesPage from "@/components/LesBibliotheques/LesBibliothequesPage.vue";
import ParaAcademiquePage from "@/components/ParaAcademique/ParaAcademiquePage.vue";
import LesApprenantsPage from "@/components/LesApprenants/LesApprenantsPage.vue";
import LesPublications from "@/components/LesPublications/LesPublications.vue";
import LesPublicationsPage from "@/components/LesPublications/LesPublicationsPage.vue";
import LesTextesPage from "@/components/Textes/LesTextesPage.vue";
import LesTextesDetailsPage from "@/components/Textes/LesTextesDetailsPage.vue";
import LaPhotothequePage from "@/components/Phototheque/LaPhotothequePage.vue";
import LesVideothequesPage from "@/components/Videoteques/LesVideothequesPage.vue";
import DetailsPhotoPage from "@/components/Phototheque/DetailsPhotoPage.vue";
import MemoireApprenantPage from "@/components/MemoireApprenant/MemoireApprenantPage.vue";

const routes = [
  
  { path: "/", name: "HomeOnePage", component: HomeOnePage },
  { path: "/home-two", name: "HomeTwoPage", component: HomeTwoPage },
  { path: "/home-three", name: "HomeThreePage", component: HomeThreePage },
  { path: "/about", name: "AboutPage", component: AboutPage },
  { path: "/services", name: "ServicesPage", component: ServicesPage },
  {
    path: "/services-two",
    name: "ServicesTwoPage",
    component: ServicesTwoPage,
  },
  {
    path: "/service-details",
    name: "ServicesDetailsPage",
    component: ServicesDetailsPage,
  },
   {
    path: "/inscription",
    name: "DemandeInscriptionPage",
    component: DemandeInscriptionPage,
  },
  
  { path: "/projects", name: "ProjectPage", component: ProjectPage },
  {
    path: "/project-details",
    name: "ProjectDetailsPage",
    component: ProjectDetailsPage,
  },
  { path: "/team", name: "TeamPage", component: TeamPage },
  { path: "/open-account", name: "AccountPage", component: AccountPage },
  { path: "/apply-loan", name: "ApplyPage", component: ApplyPage },
  { path: "/pricing", name: "PricingPage", component: PricingPage },
  { path: "/faq", name: "FaqPage", component: FaqPage },
  { path: "/faqeservice", name: "FaqEservicePage", component: FaqEservicePage },
  
  {
    path: "/testimonials",
    name: "TestimonialsPage",
    component: TestimonialsPage,
  },
  { path: "/my-account", name: "MyAccountPage", component: MyAccountPage },
  { path: "/login", name: "LoginPage", component: LoginPage },
  { path: "/register", name: "RegisterPage", component: RegisterPage },
  {
    path: "/recover-password",
    name: "RecoverPasswordPage",
    component: RecoverPasswordPage,
  },
  {
    path: "/terms-of-service",
    name: "TermsOfServicePage",
    component: TermsOfServicePage,
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicyPage",
    component: PrivacyPolicyPage,
  },
  { path: "/:pathMatch(.*)*", name: "ErrorPage", component: ErrorPage },
  { path: "/blog", name: "BlogPage", component: BlogPage },
  {
    path: "/blog-left-sidebar",
    name: "BlogLeftSidebarPage",
    component: BlogLeftSidebarPage,
  },
  {
    path: "/blog-right-sidebar",
    name: "BlogRightSidebarPage",
    component: BlogRightSidebarPage,
  },
  {
    path: "/blog-details",
    name: "BlogDetailsPage",
    component: BlogDetailsPage,
  },
  {
    path: "/blog-details-left-sidebar",
    name: "BlogDetailsLeftSidebarPage",
    component: BlogDetailsLeftSidebarPage,
  },
  {
    path: "/blog-details-right-sidebar",
    name: "BlogDetailsRightSidebarPage",
    component: BlogDetailsRightSidebarPage,
  },
  {
    path: "/view-article/:id",
    name: "ViewArticlePage",
    component: ViewArticlePage,
  },
  {
    path: "/preview-article/:id",
    name: "PreviewArticlePage",
    component: PreviewArticlePage,
  },
  {
    path: "/view-mediatheque/:id",
    name: "ViewMediathequePage",
    component: ViewMediathequePage,
  },
  { path: "/contact", name: "ContactUsPage", component: ContactUsPage },

  //Services postaux
  { path: "/colisPostaux", name: "ColisPostauxPage", component: ColisPostauxPage },
  { path: "/envoisExpress", name: "EnvoiExpressPage", component: EnvoiExpressPage },
  { path: "/philatelie", name: "PhiLateliePage", component: PhiLateliePage },
  { path: "/posteLettre", name: "PosteLettrePage", component: PosteLettrePage },
  { path: "/serviceDistribution", name: "ServiceDistributionPage", component: ServiceDistributionPage },

  //Services financiers
  { path: "/assurances", name: "Assuranceage", component: AssurancePage },
  { path: "/centreCheque", name: "CentreChequePage", component: CentreChequePage },
  { path: "/caisseNational", name: "CaisseNationalPage", component: CaisseNationalPage },
  { path: "/transfertArgent", name: "TransfertArgentPage", component: TransfertArgentPage },

  //Service public
  { path: "/servicePublic", name: "ServicePublicPage", component: ServicePublicPage },
  { path: "/servicePoste", name: "ServicePostePage", component: ServicePostePage },
  { path: "/autreService", name: "AutreServicePage", component: AutreServicePage },

  //Service connexe
  { path: "/posteVerte", name: "PosteVertePage", component: PosteVertePage },
  { path: "/posteVoyage", name: "PosteVoyagePage", component: PosteVoyagePage },
  { path: "/produitPartenariat", name: "ProduitPartenariatPage", component: ProduitPartenariatPage },
  
  //Actualite
  { path: "/actualite", name: "ActualitePostePage", component: ActualitePostePage },

   //Code d'engagement
  { path: "/code-engagement", name: "CodeEngagementPage", component: CodeEngagementPage },
  
    //Bénévoles
  { path: "/benevoles", name: "BenevolePage", component: BenevolePage },

    // Soutiens
  { path: "/soutien", name: "SoutienPage", component: SoutienPage },

      // Animateurs
  { path: "/animateur", name: "AniMateurPage", component: AnimateurPage },

    // Niveau
  { path: "/niveau", name: "NiveauPersonnelPage", component: NiveauPersonnelPage },

     // Axe Animation
  { path: "/axe", name: "AxeAnimationPage", component: AxeAnimationPage },

    // Parution
  { path: '/parution', name: 'ParutionPage', component: ParutionPage },

      // Matinéees
  { path: '/matinees', name: 'MatineesPage', component: MatineesPage },

        // Missions
  { path: '/mission', name: 'MissionPage', component: MissionPage },


  // qui sommes nous
  // { path: '/eitp/qui-sommes-nous', name: 'QuiSommesNousPage', component: QuiSommesNousPage },

    // eitpenmission
  { path: '/eitp/eitp-en-mission', name: 'EitpMissionPage', component: EitpMissionPage },

  // chronoskairos
  { path: '/eitp/chronoskairos', name: 'ChronosKairosPage', component: ChronosKairosPage },

    // notrerevue
  { path: '/eitp/notrerevue', name: 'RevuePage', component: RevuePage },

  // recherches
  { path: '/eitp/recherches', name: 'RecherchePage', component: RecherchePage },

  // recherches
  { path: '/mediatheque/formateurs', name: 'FormateurPage', component: FormateurPage },

  
  // activites
  { path: '/mediatheque/activites', name: 'ActivitePage', component: ActivitePage },

  // articles
  { path: '/mediatheque/articles', name: 'ArticlePage', component: ArticlePage },

    // nos dicsiples
  { path: '/mediatheque/nosdisciples', name: 'DisciplePage', component: DisciplePage },

    // nos videos
  { path: '/mediatheque/nosvideos', name: 'VideoPage', component: VideoPage },

  // qui sommes nous
  { path: '/mediatheque/disciples', name: 'Disciples2Page', component: Disciples2Page },

  // qui sommes nous
  { path: '/formations/nosformations', name: 'FormationPage', component: FormationPage },

  // Disciples d'emmaus
  { path: '/discipleEmmaus', name: 'discipleEmmaus', component: DiscipleEmmaius},

  // Les Equipes
  { path: '/equipes', name: 'equipes', component: Equipes},

  // Les Mouvements
  { path: '/mouvements', name: 'mouvements', component: LesMouvements},

  // Les Responsables de l'école
  { path: '/responsables', name: 'responsables', component: LesResponsables},

   // Les Tuteurs
  { path: '/tuteurs', name: 'tuteurs', component: LesTuteurs},

   // Les Animateurs
  { path: '/animateurss', name: 'animateurss', component: LesAnimateurs},

   // Sécrétariat
  { path: '/secretariat', name: 'secretariat', component: LesSecretariat},

  // Les Professeurs
  { path: '/professeurs', name: 'professeurs', component: LesProfesseursPage},
  { path: '/professeurs/:id', name: 'professeur', component:ProfesseursDetailsPage},
  

  //Qui Sommes-nous
  { path: '/quisommesnouss', name: 'quisommesnouss', component: QuiSommesNousPagess},

  //Normes Administratives
  { path: '/normeadministrative', name: 'normeadministrative', component:NormeAdministrativePage},

   //Parcours Disciples d'Emmaus
  { path: '/parcoursDisciples', name: 'parcoursDisciples', component:ParcoursDisciplesPage},

   //Parcours Disciples d'Emmaus Sup
  { path: '/parcourSup', name: 'parcourSup', component:ParcourSupPage},

  //Parcours OMEGA
  { path: '/parcourOmega', name: 'parcourOmega', component:ParcoursOMEGAPage},

  //Formation par Unite
  { path: '/parcourUnite', name: 'parcourUnite', component:ParcoursUnitePage},

   //Cafés Théologiques
  { path: '/cafePage', name: 'cafePage', component:CafePage},

    //Mission EITP
   { path: '/missionEitp', name: 'missionEitp', component:MissionEitpPage},

   //Decret
   { path: '/decret', name: 'decret', component:DecretPage},

   //Habitues
   { path: '/habitues', name: 'habitues', component:LesHabituesPage},

   //Les Auditeurs
    { path: '/auditeurs', name: 'auditeurs', component:LesAuditeursPage},

    //Liturgie
    { path: '/liturgie', name: 'liturgie', component:LaLiturgiePage},

    //Chorale
    { path: '/chorale', name: 'chorale', component:LaChoralePage},

    //Organisation
    { path: '/organisations', name: 'organisations', component:LesOrganisationsPage},

    //Revue Ecole
    { path: '/revue', name: 'revu', component:LaRevuePage},

    //LesAmisMgr
    { path: '/amis', name: 'amis', component:LesAmisPage},

    //AmiSéminaire
    { path: '/amiSeminaire', name: 'amiSeminaire', component:AmiSéminairePage},

    //PetiteVoie
    { path: '/petiteVoie', name: 'petiteVoie', component:PetiteVoiePage},

    //DisciplesEmmausDetails
    { path: '/disciplesEmmaius/:id', name: 'disciplesdetails', component:DisciplesEmmaiusDetailsPage},

    //DiesAcademicus
    {path: '/diesAcademicus', name: 'diesAcademicus',component: DiesAcademicusPage},

    //SoireeTheologiques
    {path: '/soiretheologique', name: 'soiretheologique',component: LesSoireestheologiquesPage},

    //Ceremonie Academique
    {path: '/ceremonie', name: 'ceremonie',component: CeremonieAcademiquePage},

    //Colloques
    {path: '/colloques', name: 'colloques',component: LesColloquesPage},

    //Parcours 
    {path: '/spiritual', name: 'spiritual',component: ParcoursSpirituelsPage},

    //Retraite
    {path: '/retraites', name: 'RetraitePage',component: LesRetraitePage},

    //Conference Avant
    {path: '/conferencess', name: 'ConferenceAvantPage',component: ConferenceAvantPage},

    //Recollections
    {path: '/recollections', name: 'LesRecollectionsPage',component: LesRecollectionsPage},

    //Pelerinages
    {path: '/pelerinages', name: 'PelerinagesPage',component: LesPelerinagePage},

    //RevueCulture
    {path: '/revueculture', name: 'revueculture',component: RevueCulturePage},

    //Laboratoires
    {path: '/laboratoires', name: 'laboratoires',component: LeslaboratoiresPage},

    //Bibliotheque
    {path: '/bibliothequess', name: 'bibliothequess',component:LesBibliothequesPage},

    //Paraacademique
    {path: '/paraacademiques', name: 'paraacademiques',component:ParaAcademiquePage},

    //Apprenants
    {path: '/apprenants', name: 'apprenants',component:LesApprenantsPage},

    //Publications des enseignants
    {path: '/publications', name: 'lespublications',component:LesPublicationsPage},

    {path: "/textes", name: "LesTextes", component: LesTextesPage},

    {path: "/textDetails/:id", name: "LesTextesDetails", component: LesTextesDetailsPage},

    {path: "/videotheque",name:"VideothequePage", component:LesVideothequesPage},

    {path: "/phototheque", name: "Phototheque", component: LaPhotothequePage},

    {path: "/detailsphoto/:id", name: "DetailsPhoto", component: DetailsPhotoPage},

    //Mémoire Apprenant
     {path: "/memoireApprenant", name: "MemoireApprenant", component: MemoireApprenantPage},




  //Mediatheque
  { path: "/mediatheque", name: "MediathequePostePage", component: MediathequePostePage },
  { path: "/mediathequeVideo", name: "MediathequePosteVideoPage", component: MediathequePosteVideoPage },

  { path: "/document", name: "DocumentPostePage", component: DocumentPostePage },

  //Mentions
  { path: "/mentionLegale", name: "MentionLegalPage", component: MentionLegalPage },
  { path: "/donnePersonnelle", name: "DonnePersonnellePage", component: DonnePersonnellePage },
  { path: "/cookies", name: "CooKiePage", component: CooKiePage },

  //Services Détails
  { path: "/produitTransfert", name: "ProduitTransfertPage", component: ProduitTransfertPage },
  { path: "/organisation", name: "Organisation", component: OrganisationPage },
  { path: "/statut", name: "Statut", component: StatutPage },
  { path: "/contact", name: "Contact", component: ContactUsPage },
  { path: "/activite", name: "Activite", component: Activitepage },
  { path: "/disciple", name: "Disciple", component: Disciplepage },
  { path: "/colloque", name: "Colloque", component: ColloquePage },
  { path: "/cours", name: "Cours", component: CoursPage },
  { path: "/seminaire", name: "Seminaire", component: SeminairePage },
  { path: "/conference", name: "ConferencePage", component: ConferencePage },
  { path: "/bibliotheque", name: "Bibliotheque", component: BibliothequePage },
  { path: "/librairie", name: "Librairie", component: LibrairiePage },
  { path: "/formateur", name: "Formateur", component: FormateurPage },
  { path: "/laboratoire", name: "Laboratoire", component: LaboratoirePage },
  { path: "/publication", name: "PublicationPage", component: PublicationPage },
  { path: "/revu", name: "Revu", component:  RevuPage},
  { path: "/produitColisPostaux", name: "ProduitColisPostauxPage", component: ProduitColisPostauxPage },
  { path: "/produitEnvoisExpress", name: "ProduitEnvoisExpressPage", component: ProduitEnvoisExpressPage },
  { path: "/produitPosteLettre", name: "ProduitPosteLettrePage", component: ProduitPosteLettrePage },
  { path: "/produitTransportLocation", name: "ProduitTransportLocationPage", component: ProduitTransportLocationPage },

  { path: "/simulation", name: "SimulationPage", component: SimulationPage },


];

const router = createRouter({
  //history: createWebHistory(),
  history: createWebHashHistory(),
  linkExactActiveClass: "active",
  routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

export default router;
